import React, {useEffect, useState} from "react";
import "./Groups.css";
import Row from "react-bootstrap/Row";
import Group from "./Group";
import LoadingIcon from "components/dasboardv3/components/Partials/LoadingIcon/LoadingIcon";

window.isLoadingGroups = false;

function Groups({bond, reloadTimestamp, devicesById}) {
    const [groupsById, setGroupsById] = useState({});
    const [isLoadingGroups, setIsLoadingGroups] = useState(false);

    async function reloadGroups() {
        setIsLoadingGroups(true);
        let response = await bond.get("/groups")
        let groupsIds = Object.keys(response).filter(key => !key.startsWith("_"));

        let allGroups = {};
        for (let i = 0; i < groupsIds.length; i += 10) {
            const deviceGroups = [];
            deviceGroups.push(groupsIds.slice(i, i + 10));
            const groupsRequests = deviceGroups.map(group => Promise.all(group.map(async groupId => {
                const data = await bond.get(`/groups/${groupId}`);
                return {groupId, data};
            })));
            const groupsData = await Promise.all(groupsRequests);
            for (let i = 0; i < groupsData.length; i++) {
                for (let j = 0; j < groupsData[i].length; j++) {
                    const group = groupsData[i][j];
                    allGroups[group.groupId] = group.data
                }
            }
        }

        setGroupsById(allGroups);
        setIsLoadingGroups(false);
    }

    useEffect(() => {
        if (reloadTimestamp && !window.isLoadingGroups) {
            setIsLoadingGroups(true);
            window.isLoadingGroups = true;
            reloadGroups().then(() => {
                window.isLoadingGroups = false
            });
        }
    }, [reloadTimestamp]);

    return (<div>
        {isLoadingGroups ? <div className={"d-flex justify-content-center m-2"}><LoadingIcon/>
        </div> : (Object.keys(groupsById).length > 0 ? <Row xs={1} md={2} className={"devicesRow"}>
            {Object.keys(groupsById).map(groupId => (<Group key={groupId} groupId={groupId}
                                                            groupData={groupsById[groupId]} bond={bond}/>))}
        </Row> : "")}
    </div>);
}

export default Groups;
